module.exports = __webpack_public_path__ + "assets/media/day36.39699b72.mp3";